export default __webpack_public_path__ + "static/media/1367.83c65c87.png";